import { Auth0Config } from "../../src/utils/auth0ConfigHelper";

export const auth0Config: Auth0Config = {
  auth0Tenant: "",
  authorizationServer: { issuer: "" },
  auth0Domain: "",
  clientID: "",
  callbackURL: "http://localhost:3000",
  internalOptions: {},
  extraParams: {
    login_hint: JSON.stringify({
      locale: "en_??",
      email: "",
      firstName: "",
      lastName: "",
    }),
    prompt: "",
  },
  dict: {
    signin: { title: "" },
  },
};
